/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react'
import AppContainer from './appContainer'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { persistor, store } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import SpinnerProvider from './context/spinnerContext'
import { getLocal } from './helper/storage'
import { requestFCMToken } from './firebase'
import axios from 'axios'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
function App() {
  const [fcmToken, setFCMToken] = useState(null)
  const authToken = getLocal('authToken')

  useEffect(() => {
    requestFCMToken()
      .then((token) => {
        if (token) {
          setFCMToken(token)
          // console.log('Returned FCM Token:', token)
        }
      })
      .catch((error) => {
        console.error('Error retrieving FCM Token:', error)
      })
  }, [])

  useEffect(() => {
    // Update device token only if both fcmToken and authToken are available
    if (fcmToken && authToken) {
      const payload = { deviceToken: fcmToken }

      const updateDeviceToken = async () => {
        try {
          await axios.post(`${process.env.REACT_APP_API_BASE_URL}/update-device-token`, payload, {
            headers: { Authorization: `Bearer ${authToken}` }
          })
        } catch (error) {
          console.error('Error updating device token:', error)
        }
      }

      updateDeviceToken()
    }
  }, [fcmToken, authToken])

  return (
    <>
      <SpinnerProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
              <AppContainer />
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </SpinnerProvider>
    </>
  )
}

export default App
